export const PRODUCT_DISCOUNTS_LIST_KEY = 'PRODUCT_DISCOUNTS_LIST';
export const PRODUCT_DISCOUNTS_ONE_KEY = 'PRODUCT_DISCOUNTS_ONE_KEY';
